import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';

// Score Card Component - Individual metric card with change indicator
export function ScoreCard({ label, value, change, isUp, color, available = true, subtitle }) {
  return (
    <div className="bg-[hsl(var(--surface-elevated))] rounded-lg p-4 border border-[hsl(var(--border))]">
      <p className="text-[10px] uppercase tracking-wider text-[#6B7280] mb-2">{label}</p>
      <p className={`text-2xl font-bold mb-1 ${available ? (color ? '' : 'text-white') : 'text-[#4A4A4D]'}`} style={color ? { color } : {}}>
        {available ? value : 'N/A'}
      </p>
      {change !== null && change !== undefined && available && (
        <div className="flex items-center gap-1">
          {isUp === true && <ArrowUpRight size={14} className="text-[#10B981]" />}
          {isUp === false && <ArrowDownRight size={14} className="text-[#E63946]" />}
          {isUp === null && <Minus size={14} className="text-[#6B7280]" />}
          <span className={`text-xs`} style={color ? { color } : {}} >
            {change > 0 ? `+${change}%` : change < 0 ? `${change}%` : '0%'}
          </span>
        </div>
      )}
      {subtitle && available && (
        <p className="text-[9px] text-[#6B7280] mt-1">{subtitle}</p>
      )}
      {!available && (
        <p className="text-[10px] text-[#4A4A4D]">Requires MTProto</p>
      )}
    </div>
  );
}

export default ScoreCard;
